import React from 'react';
import PropTypes from 'prop-types';

class PageBar extends React.Component {
    /**
     * 페이지 클릭
     * @param {*} page
     */
    clickNum = page => {
        if (this.props.reload !== undefined) {
            this.props.reload(page);
        }
    };

    render() {
        let items = [];
        let nowPage = this.props.nowPage;

        let start = nowPage - Math.floor(this.props.maxSize / 2);
        if (start < 1) start = 1;

        let end = start + this.props.maxSize;
        if (end > this.props.totalPage) {
            end = this.props.totalPage;
            start = end - this.props.maxSize;
            if (start < 1) start = 1;
        }

        let prev = nowPage - 1;
        if (prev < 1) prev = 1;

        let next = nowPage + 1;
        if (next > this.props.totalPage) next = this.props.totalPage;

        for (let number = start; number <= end; number++) {
            items.push(
                <a href="javascript:;" key={number} onClick={e => this.clickNum(number)} class={nowPage === number ? 'on' : ''}>
                    {number}
                </a>,
            );
        }

        return (
            <div className="rb">
                {this.props.totalPage > 1 && (
                    <div className="pageing_box">
                        {nowPage !== 1 && (
                            <a href="javascript:;" className="btn_1" onClick={e => this.clickNum(1)}>
                                <i className="feather icon-chevrons-left" /> 첫페이지
                            </a>
                        )}
                        {nowPage !== 1 && (
                            <a href="javascript:;" className="btn_1" onClick={e => this.clickNum(prev)}>
                                <i className="feather icon-chevron-left" /> 이전
                            </a>
                        )}
                        {items}
                        {nowPage !== this.props.totalPage && (
                            <a href="javascript:;" className="btn_1" onClick={e => this.clickNum(next)}>
                                다음 <i className="feather icon-chevron-right" />
                            </a>
                        )}
                        {nowPage !== this.props.totalPage && (
                            <a href="javascript:;" className="btn_1" onClick={e => this.clickNum(this.props.totalPage)}>
                                끝페이지 <i className="feather icon-chevrons-right" />
                            </a>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

PageBar.defaultProps = {
    nowPage: 10,
    totalPage: 10,
    maxSize: 10,
    href: '',
    params: '',
};

PageBar.propTypes = {
    nowPage: PropTypes.number,
    totalPage: PropTypes.number,
    maxSize: PropTypes.number,
    href: PropTypes.string,
    params: PropTypes.string,
};

export default PageBar;
